import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { http, errMsg } from "../api";

export default function CreatorAuthCallback({ onAuth }) {
  const processed = useRef(false);
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("session_id");
    http.post("/auth/creator/session", { session_id: sessionId })
      .then(r => { onAuth(r.data); navigate("/", { replace: true }); })
      .catch(e => setError(errMsg(e)));
  }, []);

  if (error) return (
    <div className="loading" data-testid="creator-auth-error">
      <div className="auth-fail-card">
        <strong>Google sign-in failed</strong>
        <p>{error}</p>
        <a className="primary" href="/creator" data-testid="creator-auth-retry">Back to creator sign-in</a>
      </div>
    </div>
  );
  return <div className="loading" data-testid="creator-auth-processing">Finishing Google sign-in…</div>;
}
